/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, SetStateAction, useEffect, useState } from "react";
import classes from "./toolBar.module.scss";
import { ReactComponent as TinyArrowDown } from "assets/svgs/tiny-arrow-down.svg";
import { ReactComponent as Notification } from "assets/svgs/notification.svg";
import classNames from "classnames";
import { MdMenu } from "react-icons/md";
import MerchantLogo from "components/MerchantLogo";
import { useOnahDispatch, useOnahSelector } from "store/hooks";
import { Popover } from "antd";
import NotificationItem from "components/NotificationItem";
import InfiniteScroll from "react-infinite-scroll-component";
import { fetchNotifications } from "store/slices/notification";
import {ReactComponent as User} from 'assets/svgs/user.svg';
import {ReactComponent as Logout} from 'assets/svgs/logout.svg';
import { useNavigate } from "react-router-dom";
import { Routes } from "routes/routes";
import { handleLogout } from "helper";

type Props = {
  progress?: number;
  setOpen?: React.Dispatch<SetStateAction<boolean>>;
};
// TODO: for MOBILE RESPONSIVENESS use xs:max-md:flex
const ToolBar: FC<Props> = ({ progress = 0, setOpen }) => {
  const hideProgress = progress >= 100;
  const { merchant } = useOnahSelector(state => state.user);
  const { notifications, totalItems, size, nextPage} = useOnahSelector(state => state.notification);
  const [showNotification, setShowNotification] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const dispatch = useOnahDispatch();
  const navigate = useNavigate();

  const handleOpenNotificationChange = (newOpen: boolean) => {
    setShowNotification(newOpen);
  };

  const handleOpenProfileChange = (newOpen: boolean) => {
    setShowProfile(newOpen);
  };
  

  const handleClick = () => {
    if (setOpen) {
      setOpen(true);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, [])

  const fetchData = async (
    page = nextPage,
  ) => {
    dispatch(  fetchNotifications({
      page,
      size,
    }))
  };

  const onLogout = () => {
    setShowProfile(false);
    handleLogout();
  };

  const onProfile = () => {
    setShowProfile(false);
    navigate(Routes.settings);
  };

  const renderNotificationContent = () => {
    return (
      <div className="h-[422px] overflow-auto px-[4px]" id="notification_wrapper">
        <InfiniteScroll     
          dataLength={totalItems}
          scrollableTarget="notification_wrapper"
          next={() => fetchData()}
          hasMore={notifications.length !== totalItems}
          loader={<h4 className="text-center font-acorn text-gray-subTextHint">Loading...</h4>}
          endMessage={
            <p className="text-center font-acorn text-gray-placeholder mt-[12px]">
              <b>Yay! You have seen it all</b>
            </p>
          }
        >
          {notifications.map(notification => (
            <NotificationItem 
              key={notification.id} 
              item={notification} 
            />
          )
          )}
        </InfiniteScroll>
      </div>
    )
  };

  const renderProfileContent = () => {
    return (
      <div className="text-black text-[18px] font-semibold">
        <div 
          onClick={() => onProfile()}
          className="flex items-center gap-x-[6px] py-[14px] px-[8px] hover:bg-gray-restingField border-b border-b-gray-inputFieldStroke" 
          role="button">
          <User className="w-[12px] h-[12px]"/>
          <p>Profile</p>
        </div>
        <div 
          onClick={() => onLogout()}
          className="flex items-center gap-x-[6px] py-[14px] px-[8px] hover:bg-gray-restingField" role="button">
          <Logout/>
          <p>Logout</p>
        </div>
      </div>
    )
  };

  return (
    <nav
      className={classNames(classes.tool__bar, "max-2xl:px-[20px] px-[40px]")}
    >
      {/* LEFT ITEM */}
      {/* space-x-[40px] max-2xl:space-x-[20px] */}
      <div className="flex items-center ">
        <div className="m-3 lg:hidden" onClick={handleClick}>
          <MdMenu size={25} />
        </div>
        <MerchantLogo className="md:flex hidden" />
      </div>
      {/* RIGHT ITEM */}
      <div className="flex items-center">
        {!hideProgress && (
          <div className="flex items-center space-x-1">
            <p className="font-bold max-2xl:text-[14px] text-[18px]">{progress}%</p>
            <div className="bg-gray-inputFieldStroke max-2xl:w-[149px] w-[159px] h-[16px] max-2xl:h-[10px] rounded-[20px]">
              <div
                className="h-[100%] rounded-[20px] bg-success"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        )}
        <Popover 
          trigger="click" 
          content={renderNotificationContent()} 
          open={showNotification}
          overlayClassName="w-[380px] [&_.ant-popover-inner]:pt-[24px] [&_.ant-popover-inner]:pb-[27px] "
          autoAdjustOverflow
          arrowPointAtCenter={true}
          placement="bottom"
          destroyTooltipOnHide
          showArrow={false}
          onOpenChange={handleOpenNotificationChange}
          title={<h5 className="text-[18px] 2xl:text-[20px] font-acorn font-bold text-gray-placeholder mx-[29px] 2xl:mx-[31px] mb-[14px] 2xl:mb-[16px]">Notifications</h5>}>
            <Notification className="ml-[20px] 2xl:ml-[40px] max-2xl:w-[24px]" />     
        </Popover>
        <div className="ml-[24px]">
          <Popover 
            trigger="click" 
            content={renderProfileContent()} 
            open={showProfile}
            overlayClassName="w-[260px] [&_.ant-popover-inner]:p-[16px]"
            autoAdjustOverflow
            showArrow={false}
            arrowPointAtCenter={true}
            placement="bottom"
            destroyTooltipOnHide
            onOpenChange={handleOpenProfileChange}
            title={null}>
              <div className="flex items-center">
                {merchant?.logo ? (
                  <img 
                    src={merchant.logo} 
                    alt={`${merchant.name} logo`} 
                    className="2xl:h-[40px] h-[30px] 2xl:w-[40px] w-[30px] rounded-full object-cover object-center cursor-pointer"
                  />
                ) : (
                  <div className="2xl:h-[40px] h-[30px] 2xl:w-[40px] w-[30px] bg-yellow-300 rounded-full justify-center items-center flex mr-[2px] cursor-pointer">
                    <span className="text-white font-bold 2xl:text-[20px] text-[16px]">
                      {merchant?.name.charAt(0) ?? 'O'}
                    </span>
                  </div>
                )}
                <TinyArrowDown />
              </div>
          </Popover>
        </div>
      </div>
    </nav>
  );
};

export default ToolBar;
